import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { motion } from "framer-motion";
import { useState } from "react";
import Logo from "./logo";

export default function Footer() {
  const socials = [
    { icon: faFacebook, colors: "from-blue-600 to-indigo-700", link: "https://www.facebook.com/profile.php?id=100067950415851" },
  ];

  // Local state for showing tooltip
  const [copied, setCopied] = useState("");

  // Copy handler
  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text);
    setCopied(label);
    setTimeout(() => setCopied(""), 1500); // tooltip disappears after 1.5s
  };

  return (
    <footer className="relative bg-gradient-to-b from-white via-[#f8faff] to-[#eef5ff] border-t border-gray-200 overflow-hidden">
      {/* subtle background pattern */}
      <div className="absolute inset-0 bg-white bg-repeat opacity-15 pointer-events-none"></div>

      <div className="relative z-10 container mx-auto px-6 pt-10 pb-4 text-gray-700">
        {/* top section */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 mb-6 text-center lg:text-left">
          {/* brand */}
          <div className="flex flex-col items-center lg:items-start gap-1">
            <Logo size={50} />
          </div>

          {/* newsletter */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              alert("🎉 Subscribed successfully!");
            }}
            className="flex w-full sm:w-[60%] lg:w-[40%] bg-white rounded-full shadow-sm overflow-hidden border border-gray-200"
          >
            <input
              type="email"
              placeholder="Enter your email"
              required
              className="flex-1 px-4 py-2 text-sm outline-none text-gray-700 placeholder-gray-400"
            />
            <button
              type="submit"
              className="bg-gradient-to-tr from-blue-600 to-cyan-500 text-white font-semibold px-5 py-2 hover:opacity-90 text-sm"
            >
              Subscribe
            </button>
          </form>

          {/* socials */}
          <div className="flex space-x-3 justify-center">
            {socials.map((s, i) => (
              <motion.a
                key={i}
                href={s.link}
                target="_blank"                // ✅ opens in new tab
                rel="noopener noreferrer"     // ✅ prevents security issues
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className={`w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-tr ${s.colors} text-white text-sm shadow hover:shadow-lg transition-all`}
              >
                <FontAwesomeIcon icon={s.icon} />
              </motion.a>
            ))}
          </div>

        </div>

        {/* quick links */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 mb-3 text-sm">
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">Products</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/domains" className="hover:text-blue-600 transition">
                  Domains
                </Link>
              </li>
              <li>
                <Link to="/hosting" className="hover:text-blue-600 transition">
                  Web Hosting
                </Link>
              </li>
              <li>
                <Link to="/other-services" className="hover:text-blue-600 transition">
                  Other Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-800 mb-2">Company</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/" className="hover:text-blue-600 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-blue-600 transition">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-600 transition">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* <div>
            <h4 className="font-semibold text-gray-800 mb-2">Legal</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/terms" className="hover:text-blue-600 transition">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-blue-600 transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/refund-policy"
                  className="hover:text-blue-600 transition"
                >
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div> */}

          {/* contact */}
          <div className="relative">
            <h4 className="font-semibold text-gray-800 mb-2">Contact</h4>
            <ul className="space-y-1 text-[13px]">
              <li
                className="cursor-pointer hover:text-blue-600 transition relative inline-block"
                onClick={() =>
                  handleCopy("+923214994888", "phone")
                }
              >
                📞 +92 321 4994888
                {copied === "phone" && (
                  <span className="absolute -top-5 left-1/2 -translate-x-1/2 text-[11px] bg-blue-600 text-white px-2 py-0.5 rounded shadow">
                    Copied!
                  </span>
                )}
              </li>
              <li>📍 Lahore, Pakistan</li>
              <li
                className="cursor-pointer hover:text-blue-600 transition relative inline-block"
                onClick={() =>
                  handleCopy("info@synergysoft.com.pk", "email")
                }
              >
                ✉️ info@synergysoft.com.pk
                {copied === "email" && (
                  <span className="absolute -top-5 left-1/2 -translate-x-1/2 text-[11px] bg-blue-600 text-white px-2 py-0.5 rounded shadow">
                    Copied!
                  </span>
                )}
              </li>
            </ul>
          </div>
        </div>

        {/* bottom bar */}
        <div className="border-t border-gray-200 mt-3 pt-1 pb-1 text-center text-[11px] text-gray-500 leading-tight">
          © {new Date().getFullYear()}{" "}
          <span className="font-semibold text-blue-600">Synergy Soft International</span>. All
          rights reserved.
        </div>
      </div>
    </footer>
  );
}
